<!-- <img style="width: 95%"
  src="https://my.torrentfx.com.cn/Content/images/customImages/loginLogo_65245a9d-faa3-48d7-beb2-52f45846eb36.png"
  alt="Logo"> -->
  <img src="/assets/logo.png" alt="logo" style="height: 100%;">